<template>
  <div id="app">
    <the-header>
      <template #actions>
        <app-button text to="/tryout">Add Tryout</app-button>
      </template>
    </the-header>

    <router-view></router-view>
  </div>
</template>

<script>
import AppButton from '@/components/AppButton.vue'
import TheHeader from './components/TheHeader.vue'

export default {
  name: 'App',
  components: {
    AppButton,
    TheHeader,
  },
}
</script>
